import { NumberSymbol } from "@angular/common";
import { AnyCnameRecord } from "dns";

export class Measure{
    id: number;
    code: string;
    name: string;
    nameEnglish: string;
    measureType: any;
}
